module.exports = __webpack_public_path__ + "static/media/run_10.a18a31e6.png";